import React, { useEffect, useState } from 'react';
import Modal from 'design-system/Modal/Modal';
import { Button, SvgIcon } from 'design-system';
import EscapeIcon from 'design-system/Icons/EscapeIcon';
import Input from 'design-system/Input/Input';
import ErrorWarningLineIcon from 'design-system/Icons/ErrorWarningLineIcon';
import Alert from 'design-system/Alert/Alert';
import { defaultErrorMessage } from '../../../constants/errorMessages';

const AddOrganizationModal = ({ onClose, organizationCreate, handleSave }) => {
    const [errorAlert, setErrorAlert] = useState({ show: false, statusCode: null });
    const [errorMessage, setErrorMessage] = useState(null);

    const [organizationData, setOrganizationData] = useState({
        name: '',
    });
    const [errorFields, setErrorFields] = useState({
        name: false,
    });

    const handleInputChange = (e) => {
        setOrganizationData((prevCredentials) => ({
            ...prevCredentials,
            [e.target.name]: e.target.value,
        }));
    };

    const handleSubmit = async () => {
        if (!organizationData.name) {
            setErrorFields({
                name: true,
            });
            return;
        }

        const { success, error } = await organizationCreate.request({
            data: organizationData,
        });

        if (success) {
            onClose();
            handleSave();
        }
        if (error) {
            setErrorAlert({ show: true, statusCode: error?.status });
        }
    };

    return (
        <Modal size="small" onClose={onClose}>
            <div className="flex flex-col gap-[16px]">
                <div className="flex justify-between items-center gap-2">
                    <h2 className="font-heading-bold text-heading-bold-m text-black">
                        Create Your Organization
                    </h2>
                    <div onClick={onClose} className="cursor-pointer">
                        <SvgIcon color="#1F2125" icon={EscapeIcon} size="rectangle"></SvgIcon>
                    </div>
                </div>
                <Input
                    label={'Organization Name'}
                    value={organizationData.name}
                    placeholder="Name"
                    name="name"
                    size="xs"
                    onChange={handleInputChange}
                    isRequired
                    state={errorFields.name ? 'error' : 'default'}
                    errorMessage="Please fill in this field."
                />
                <p>
                    You can only create one organization per account. <br /> Are you sure?
                </p>
                <div className="flex justify-between">
                    <Button type="ghost" text="Cancel" size="sm" onClick={onClose} />
                    <Button type="primary" text={'Confirm'} size="sm" onClick={handleSubmit} />
                </div>
            </div>
            {errorAlert.show && (
                <Alert
                    status="critical"
                    message={errorMessage || defaultErrorMessage}
                    icon={ErrorWarningLineIcon}
                    statusCode={errorAlert.statusCode}
                    autoCloseInMS={3000}
                    handleClose={() => setErrorAlert({ show: false, statusCode: null })}
                />
            )}
        </Modal>
    );
};

export default AddOrganizationModal;
